import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { APP_NAME } from '../../phito-core.config';

@Injectable({ providedIn: 'root' })
export class PhitoTitleStrategy extends TitleStrategy {

    private appName = inject(APP_NAME);

    constructor(private readonly title: Title) {
        super();
    }

    override updateTitle(routerState: RouterStateSnapshot) {
        const title = this.buildTitle(routerState);
        if (title !== undefined) {
            this.title.setTitle(this.appName?.trim() + ' | ' + title);
        } else {
            this.title.setTitle(this.appName?.trim());
        }
    }
}